import { render, staticRenderFns } from "./EditPressNewList.vue?vue&type=template&id=5958710a"
import script from "./EditPressNewList.vue?vue&type=script&lang=js"
export * from "./EditPressNewList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports